/* Rachelis cart helpers: terms agreement guard, direct checkout button,
   and "complete the look" suggestions in the cart drawer. */
(function () {
  const TERMS_ATTRIBUTE = 'Customer agreed to terms';
  const state = window.rachelisTerms || { enabled: false, agreed: true };

  /* ---------- Terms agreement ---------- */

  function termsCheckboxes() {
    return document.querySelectorAll('[data-rachelis-terms-checkbox]');
  }

  function clearTermsErrors() {
    document.querySelectorAll('[data-rachelis-terms-error]').forEach((error) => {
      error.textContent = '';
    });
    termsCheckboxes().forEach((checkbox) => checkbox.removeAttribute('aria-invalid'));
  }

  function showTermsError(container) {
    const terms =
      (container && container.querySelector('[data-rachelis-terms]')) || document.querySelector('[data-rachelis-terms]');
    if (!terms) return;
    const error = terms.querySelector('[data-rachelis-terms-error]');
    const checkbox = terms.querySelector('[data-rachelis-terms-checkbox]');
    error.textContent = error.dataset.message;
    checkbox.setAttribute('aria-invalid', 'true');
    checkbox.focus();
    terms.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function saveTerms(agreed) {
    state.agreed = agreed;
    const value = agreed ? 'Agreed at ' + new Date().toLocaleString('he-IL') : 'No';
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [TERMS_ATTRIBUTE]: value } }),
    }).catch(() => {});
  }

  // Express checkout buttons (e.g. PayPal) render in iframes we can't intercept, so while the
  // terms are not accepted they get a covering button that explains what to do instead.
  function updateExpressGuards() {
    document.querySelectorAll('.additional-checkout-buttons').forEach((container) => {
      let guard = container.querySelector('.rachelis-express-guard');
      const pending = state.enabled && !state.agreed;
      container.classList.toggle('rachelis-express--pending', pending);
      if (pending && !guard) {
        guard = document.createElement('button');
        guard.type = 'button';
        guard.className = 'rachelis-express-guard';
        guard.setAttribute('aria-label', 'יש לאשר את תנאי השימוש לפני תשלום מהיר');
        guard.addEventListener('click', () => showTermsError(document.getElementById('MainContent')));
        container.appendChild(guard);
      } else if (!pending && guard) {
        guard.remove();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', updateExpressGuards);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-rachelis-terms-checkbox]')) return;
    const agreed = event.target.checked;
    termsCheckboxes().forEach((checkbox) => {
      checkbox.checked = agreed;
    });
    clearTermsErrors();
    saveTerms(agreed);
    updateExpressGuards();
  });

  // Checkout buttons stay clickable; without agreement we explain why instead of silently blocking.
  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest('[name="checkout"]');
      if (!checkoutButton || !state.enabled || state.agreed) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showTermsError(checkoutButton.closest('cart-drawer') || document.getElementById('MainContent'));
    },
    true
  );

  // Coming from the product page "רכישה" button without agreement.
  if (new URLSearchParams(window.location.search).get('terms') === 'required') {
    document.addEventListener('DOMContentLoaded', () => showTermsError(document.getElementById('MainContent')));
  }

  /* ---------- Direct checkout ("רכישה") on the product page ---------- */

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rachelis-direct-checkout-button');
    if (!button) return;
    const form = document.getElementById(button.getAttribute('form')) || button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => {
        if (!response.ok) throw response;
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        window.location.href = !state.enabled || state.agreed ? '/checkout' : cartUrl + '?terms=required';
      })
      .catch(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
  });

  // Keep "רכישה" enabled/disabled together with the add-to-cart button when the variant changes.
  function syncDirectCheckoutButtons() {
    document.querySelectorAll('.rachelis-direct-checkout-button').forEach((button) => {
      const sectionId = button.id.replace('ProductDirectCheckout-', '');
      const addButton = document.getElementById('ProductSubmitButton-' + sectionId);
      if (addButton) button.disabled = addButton.disabled;
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncDirectCheckoutButtons));
  }
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) setTimeout(syncDirectCheckoutButtons, 600);
  });

  /* ---------- Complete the look (cart drawer) ---------- */

  const recommendationCache = new Map();
  // Same look as the store's money format (₪330.00)
  const moneyFormatter = { format: (amount) => '₪' + amount.toFixed(2) };

  function fetchRecommendations(url, productId, intent) {
    const key = productId + ':' + intent;
    if (!recommendationCache.has(key)) {
      recommendationCache.set(
        key,
        fetch(`${url}.json?product_id=${productId}&limit=8&intent=${intent}`)
          .then((response) => (response.ok ? response.json() : { products: [] }))
          .then((data) => data.products || [])
          .catch(() => [])
      );
    }
    return recommendationCache.get(key);
  }

  class RachelisCartUpsell extends HTMLElement {
    connectedCallback() {
      this.load();
    }

    async load() {
      const exclude = (this.dataset.exclude || '').split(',').map(Number);
      const keep = (products) => products.filter((product) => product.available && !exclude.includes(product.id));
      let products = keep(await fetchRecommendations(this.dataset.url, this.dataset.productId, 'complementary'));
      if (products.length < 3) {
        const related = keep(await fetchRecommendations(this.dataset.url, this.dataset.productId, 'related'));
        related.forEach((product) => {
          if (!products.some((existing) => existing.id === product.id)) products.push(product);
        });
      }
      products = products.slice(0, 3);
      if (!products.length || !this.isConnected) return;

      const list = this.querySelector('.rachelis-upsell__list');
      list.innerHTML = '';
      products.forEach((product) => list.appendChild(this.renderItem(product)));
      this.hidden = false;
    }

    renderItem(product) {
      const item = document.createElement('li');
      item.className = 'rachelis-upsell__item';

      const image = product.featured_image
        ? `<img src="${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=160" alt="" width="80" height="100" loading="lazy">`
        : '';
      const variants = product.variants.filter((variant) => variant.available);
      const singleVariant = product.variants.length === 1 && variants.length === 1;

      item.innerHTML = `
        <a class="rachelis-upsell__media" href="${product.url}" tabindex="-1" aria-hidden="true">${image}</a>
        <div class="rachelis-upsell__info">
          <a class="rachelis-upsell__name" href="${product.url}"></a>
          <span class="rachelis-upsell__price">${moneyFormatter.format(product.price / 100)}</span>
        </div>`;
      item.querySelector('.rachelis-upsell__name').textContent = product.title;

      if (singleVariant) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rachelis-upsell__add button button--secondary';
        button.textContent = 'הוספה';
        button.setAttribute('aria-label', `הוספת ${product.title} לעגלה`);
        button.addEventListener('click', () => this.add(button, variants[0].id));
        item.appendChild(button);
      } else {
        const link = document.createElement('a');
        link.className = 'rachelis-upsell__add button button--secondary';
        link.href = product.url;
        link.textContent = 'לבחירת מידה';
        link.setAttribute('aria-label', `לבחירת מידה – ${product.title}`);
        item.appendChild(link);
      }
      return item;
    }

    add(button, variantId) {
      const drawer = document.querySelector('cart-drawer');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status || !drawer) throw parsedState;
          drawer.renderContents({ ...parsedState, id: variantId });
        })
        .catch(() => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    }
  }

  if (!customElements.get('rachelis-cart-upsell')) customElements.define('rachelis-cart-upsell', RachelisCartUpsell);
})();
